var _path, _g, _g2, _g3, _g4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAssetServicesCompletedEmptystate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 110,
    viewBox: "0 0 114 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 74H89.5C107 74 114 67 114 49.5V28.5C114 11 107 4 89.5 4H68.5C51 4 44 11 44 28.5V49.5C44 67 51 74 68.5 74Z",
    fill: "url(#paint0_linear_5869_14050)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5869_14050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5 90H65.5C83 90 90 83 90 65.5V44.5C90 27 83 20 65.5 20H44.5C27 20 20 27 20 44.5V65.5C20 83 27 90 44.5 90Z",
    fill: "url(#paint1_linear_5869_14050)",
    fillOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_5869_14050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 90H63.5C81 90 88 83 88 65.5V44.5C88 27 81 20 63.5 20H42.5C25 20 18 27 18 44.5V65.5C18 83 25 90 42.5 90Z",
    fill: "url(#paint2_linear_5869_14050)",
    fillOpacity: 0.16
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_5869_14050)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1572 25.1572C27.3041 21.0102 33.676 19.25 42.5 19.25H63.5C72.324 19.25 78.6959 21.0102 82.8428 25.1572C86.9898 29.3041 88.75 35.676 88.75 44.5V65.5C88.75 74.324 86.9898 80.6959 82.8428 84.8428C78.6959 88.9898 72.324 90.75 63.5 90.75H42.5C33.676 90.75 27.3041 88.9898 23.1572 84.8428C19.0102 80.6959 17.25 74.324 17.25 65.5V44.5C17.25 35.676 19.0102 29.3041 23.1572 25.1572ZM24.2178 26.2178C20.4898 29.9459 18.75 35.824 18.75 44.5V65.5C18.75 74.176 20.4898 80.0541 24.2178 83.7822C27.9459 87.5102 33.824 89.25 42.5 89.25H63.5C72.176 89.25 78.0541 87.5102 81.7822 83.7822C85.5102 80.0541 87.25 74.176 87.25 65.5V44.5C87.25 35.824 85.5102 29.9459 81.7822 26.2178C78.0541 22.4898 72.176 20.75 63.5 20.75H42.5C33.824 20.75 27.9459 22.4898 24.2178 26.2178Z",
    fill: "url(#paint3_linear_5869_14050)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_5869_14050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7832 62.2837L61.9457 51.1212L59.729 48.9045L50.7832 57.8503L46.2707 53.3378L44.054 55.5545L50.7832 62.2837ZM52.9998 70.8337C50.8096 70.8337 48.7512 70.4178 46.8248 69.586C44.8984 68.7553 43.2228 67.6274 41.7978 66.2024C40.3728 64.7774 39.2449 63.1017 38.4142 61.1753C37.5824 59.2489 37.1665 57.1906 37.1665 55.0003C37.1665 52.81 37.5824 50.7517 38.4142 48.8253C39.2449 46.8989 40.3728 45.2232 41.7978 43.7982C43.2228 42.3732 44.8984 41.2449 46.8248 40.4131C48.7512 39.5824 50.8096 39.167 52.9998 39.167C55.1901 39.167 57.2484 39.5824 59.1748 40.4131C61.1012 41.2449 62.7769 42.3732 64.2019 43.7982C65.6269 45.2232 66.7548 46.8989 67.5855 48.8253C68.4173 50.7517 68.8332 52.81 68.8332 55.0003C68.8332 57.1906 68.4173 59.2489 67.5855 61.1753C66.7548 63.1017 65.6269 64.7774 64.2019 66.2024C62.7769 67.6274 61.1012 68.7553 59.1748 69.586C57.2484 70.4178 55.1901 70.8337 52.9998 70.8337Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5869_14050",
    x: 0,
    y: 0,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_5869_14050"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_5869_14050",
    x: 2,
    y: 4,
    width: 102,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5869_14050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5869_14050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_5869_14050",
    x: 1.25,
    y: 3.25,
    width: 103.5,
    height: 103.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5869_14050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5869_14050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5869_14050",
    x: 37.1665,
    y: 39.167,
    width: 31.6665,
    height: 33.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5869_14050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5869_14050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5869_14050",
    x1: 49,
    y1: 11,
    x2: 102,
    y2: 79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B47FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5869_14050",
    x1: 25,
    y1: 27,
    x2: 78,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B47FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5869_14050",
    x1: 23,
    y1: 27,
    x2: 76,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B47FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5869_14050",
    x1: 81,
    y1: 26,
    x2: 24,
    y2: 84.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0285714,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetServicesCompletedEmptystate);
export default __webpack_public_path__ + "static/media/asset-services-completed-emptystate.9dedeed0f9d1c5918bcc7baca8563c4a.svg";
export { ForwardRef as ReactComponent };